import { ScreenWrapper } from '@/components/wrappers/ScreenWrapper';
import { LotBidAndInfoSection } from '../../components/containers/LotBidAndInfoSection';
import { Container, useMediaQuery } from '@mui/material';
import { useLotBidAndInfoStyles } from './LotBidAndInfo.styles';
import { BiddingTable } from '../../components/containers/BiddingTable';
import { LotClosingValidation } from 'prembid-shared-library-npm/types';
import { useParams } from 'react-router';
import { LotContactList } from '../../components/containers/LotContactList';
import { FC, useEffect } from 'react';
import { EnquiryForm } from '../../components/composite/EnquiryForm';

const LotBidAndInfo: FC = () => {

    const { classes: { containerWidth } } = useLotBidAndInfoStyles();
    const { auctionId, lotId }: any = useParams();

    // Narrow windows: the panel goes under the photos and title (rendered in one place only).
    const narrow = useMediaQuery('(max-width: 899.98px)');
    const panel = <BiddingTable auctionId={auctionId} lotId={lotId} showCompactView={false} />;
    // Desktop: contact and enquiry on the right under the bidding panel; narrow: at the end, as on mobile.
    const contactAndEnquiry = <>
        <section className="pb-info-section">
            <div className="pb-info-heading">Contact</div>
            <LotContactList lotId={lotId} />
        </section>

        <section className="pb-info-section">
            <EnquiryForm lotId={lotId} />
        </section>
    </>;

    useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'auto' })
    }, []);

    return (
        <ScreenWrapper>
            <Container maxWidth={false} className={containerWidth}>
                <div className="pb-lot-layout">
                    <div className="pb-lot-main">
                        <LotBidAndInfoSection auctionId={auctionId} lotId={lotId} afterTitle={narrow ? panel : undefined} />
                        {narrow && contactAndEnquiry}
                    </div>
                    {!narrow && (
                        <aside className="pb-lot-side">
                            {panel}
                            {contactAndEnquiry}
                        </aside>
                    )}
                </div>
            </Container>
        </ScreenWrapper>
    )
};

export default LotBidAndInfo;